import { FC } from 'react';
import type { DataTableCellIndexCoordinate } from '@/components/UI/DataTableV2/DataTable.model';
import { useDataTable } from '@/components/UI/DataTableV2/DataTableProvider';
import { useCellEditability } from '@/components/UI/DataTableV2/hooks/useCellEditability';
import { DataTableDefaultCell } from './DataTableDefaultCell';
import { DataTableTimestampCell } from './DataTableTimestampCell';
import { DataTableReadonlyCell } from './DataTableReadonlyCell';

interface CellTypeRouterProps {
  coordinate: DataTableCellIndexCoordinate;
  positionOffset: { x: number; y: number };
}

export const CellTypeRouter: FC<CellTypeRouterProps> = ({ coordinate, positionOffset }) => {
  const { dataTableService } = useDataTable();
  const { isEditable } = useCellEditability(coordinate);
  const column = dataTableService.columnByIndex(coordinate.column);

  if (!isEditable) {
    return <DataTableReadonlyCell coordinate={coordinate} positionOffset={positionOffset} />;
  }
  switch (column?.type) {
    case 'timestamp':
    case 'timestampBaseline':
      return <DataTableTimestampCell coordinate={coordinate} positionOffset={positionOffset} />;

    case 'timestampBaselineRelative':
    case 'formula':
    case 'observation':
      return <DataTableReadonlyCell coordinate={coordinate} positionOffset={positionOffset} />;

    case 'measurement':
      if (column.measurement?.is_calculated ?? false) {
        return <DataTableReadonlyCell coordinate={coordinate} positionOffset={positionOffset} />;
      }
      return <DataTableDefaultCell coordinate={coordinate} positionOffset={positionOffset} />;

    case 'text':
    case 'number':
    default:
      return <DataTableDefaultCell coordinate={coordinate} positionOffset={positionOffset} />;
  }
};
